import { memo, useContext } from "react";
import { AppConfigContext } from "../../core/AppConfigContext";
import { DateUtilsContext } from "../../core/DateUtilsContext";
import { BaseDateTimeRendererProps } from "./types";

export type DateTimeRendererProps = BaseDateTimeRendererProps;

export const DateTimeRenderer = memo<DateTimeRendererProps>(({ value, dateFormat, timeZone }) => {
  const appConfig = useContext(AppConfigContext);
  const { formatDateString } = useContext(DateUtilsContext);

  return (
    <>
      {formatDateString(value, dateFormat || appConfig?.dateTimeFormat, timeZone || appConfig?.timeZone)}
    </>
  );
});
